module.exports = __webpack_public_path__ + "static/media/partnership.6c71ce00.svg";